<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12">
        <v-card>
          <v-card-title
            class="mx-3 px-0 mb-3"
            style="border-bottom: 2px solid #d7531f"
          >
            <v-col cols="12" md="6">
              <v-icon style="margin-right: 20px; color: #00294b" size="50">
                mdi-account-multiple-plus
              </v-icon>
              Indicações
            </v-col>
          </v-card-title>
          <v-card-text>
            <h3
              style="
                font-family: poppins;
                font-weight: 600;
                color: #686868 !important;
              "
            >
              Faça novas indicações com o link abaixo
            </h3>
            <v-row justify="center" align="center" class="heigthMobile">
              <v-col
                cols="12"
                md="10"
                align="center"
                class="d-flex align-center"
              >
                <input
                  class="widthMobile"
                  style="padding: 5px; width: 100%; font-size: 15px"
                  v-on:focus="$event.target.select()"
                  ref="clone"
                  readonly
                  :value="urlIndicacao"
                />
              </v-col>
              <v-col cols="12" md="2" class="d-flex align-center">
                <v-btn small outlined color="#00294b" @click="getIndicacao">
                  <v-icon>mdi-content-copy</v-icon> Copiar link
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- <v-col cols="12" md="12">
                <v-card style="padding: 20px">
                    <v-card-title>
                        <v-icon style="margin-right: 20px; color: #00294B; font-family: Poppins !important" size="50">
                            mdi-playlist-check</v-icon>
                        Minhas indicações
                    </v-card-title>
                    <v-row>
                        <v-col cols="12" md="6" class="d-flex">
                            <v-icon size="80"  style="margin-right: 20px; color: #00294B;">mdi-account-plus</v-icon>
                            <div class="d-flex flex-column">
                            <span style="font-family: poppins; font-weight: 600">Indicações</span>
                            <span>0</span>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex">
                            <v-img src="../assets/moeda-ribus.png" contain width="5px"></v-img>
                            <span style="color: #797A7C">Você já ganhou</span>
                            <h1 style="font-family: poppins; color: #002139"></h1>
                        </v-col>        
                    </v-row>
                </v-card>
            </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    title: String,
  },
  data: () => ({
    urlIndicacao: "",
  }),

  methods: {
    getIndicacao() {
      this.$refs.clone.focus();
      document.execCommand("copy");
      this.$root.$emit("show-snack", {
        type: `success`,
        text: `Link copiado com sucesso!.`,
      });
    },
  },
  mounted() {
    this.user = this.$store.state.user;

    if (this.user.address.state == "") {
      this.user.address.state = {};
    }
    this.urlIndicacao =
      "https://marketplace.ribus.com.br/convite/" + this.user.login;

    let cat = [];
    this.user.category_user_rels.forEach((element) => {
      cat.push(element.category_id);
    });
    this.categorias = cat;
  },
};
</script>
